/**
 * 取消原因创建或编辑
 */
import React from 'react';
import {
    Modal,
    message,
    Form,
    Input,
    InputNumber,
    Radio,
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import model from '@/reducers/system/parameter/model';


const FormItem = Form.Item;//表单校验
const formItemLayout = {
    labelCol: {
        sm: { span: 5 },
    },
    wrapperCol: {
        sm: { span: 19 },
    },
};


class ReasonModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleTag: this.props.title,
            visible: this.props.visible,
            confirmLoading: false,
            typeInput: this.props.data === undefined ? '' : this.props.data.className, // 分类名称


        };

    }
    formRef = React.createRef();
    componentDidMount() {
        const { data } = this.props;
        // if (data) {
        //     // this.props.getApplyDetail({ id: data });//详情
        // }
    }

    componentWillUnmount() {
        // this.props.getCleanDetail();
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }


    handleSubmit = () => {//表单校验
        this.formRef.current.validateFields().then(async (fieldsValue) => {
            const { reason, status, sortNo, cancelUseScene } = fieldsValue;
            const { data, curTabID } = this.props;
            let url = data ? '/?cmd=com.xqxc.api.pig.mis.biz.platform.CancelReasonsMisService.updateCancelReasons': '/?cmd=com.xqxc.api.pig.mis.biz.platform.CancelReasonsMisService.addCancelReasons'
            let submitData = {
                id: data ? data.id : undefined,
                systemType: curTabID == 1 ? 'USER_APP' : 'RIDER_APP',
                reason,
                sortNo,
                status,
                cancelUseScene: curTabID == 2 ? cancelUseScene : undefined,
            };
            
            this.setState({ confirmLoading: true }, () => {
                http(url, submitData, 'POST').then(() => {
                    data ? message.success('更新成功') : message.success('新建成功');
                    this.setState({
                        confirmLoading: false,
                        visible: false,
                    });
                    this.props.closeMode(true);
                }).catch((e = {}) => {
                    message.error(e.message);
                    this.setState({
                        confirmLoading: false,
                    });
                });
            });

        });
    };


    render() {
        const { visible, confirmLoading, titleTag } = this.state;
        // const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;

        const { data = {}, curTabID } = this.props;
        const {
            reason,
            sortNo,
            status,
            cancelUseScene
        } = data;
        return (
            <Modal
                width={470}
                centered
                title={titleTag}
                visible={visible}
                confirmLoading={confirmLoading}
                onOk={this.handleSubmit}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form {...formItemLayout} className="create-form" ref={this.formRef}>
                        <FormItem
                            name='reason'
                            label='取消原因'
                            rules={[{ required: true, message: '请输入取消原因', whitespace: true }]}
                            initialValue={reason}
                        >
                            <Input maxLength={24} placeholder='请输入' />
                        </FormItem>
                        <FormItem
                            name='sortNo'
                            label='排序'
                            rules={[{ required: true, message: '请输入排序' }]}
                            initialValue={sortNo}
                        >

                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={99}
                                precision={0}
                                placeholder='请输入'
                            />

                        </FormItem>
                        <FormItem
                            name='status'
                            label='状态'
                            rules={[{ required: true, message: '请选择状态' }]}
                            initialValue={status}
                        >

                            <Radio.Group>
                                <Radio value={1}>启用</Radio>
                                <Radio value={0}>停用</Radio>
                            </Radio.Group>

                        </FormItem>
                        {curTabID == 2 && <FormItem
                            name='cancelUseScene'
                            label='使用场景'
                            rules={[{ required: true, message: '请选择使用场景' }]}
                            initialValue={cancelUseScene}
                        >

                            <Radio.Group>
                                <Radio value={'NOT_ARRIVE_PICKUP_POINT_CANCEL'}>未到达取件点取消</Radio>
                                <Radio value={'ARRIVE_PICKUP_POINT_CANCEL'}>已到达取件点后取消</Radio>
                            </Radio.Group>

                        </FormItem>}
                    </Form>
                </div>
            </Modal>
        );

    }
}

ReasonModal.propTypes = {
    data: PropTypes.object, // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    getRiskcontrol: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        CancelUseSceneEnum: state.parameter.CancelUseSceneEnum,
    };
};
export default connect(mapStateToProps, {...model.actions})(ReasonModal);